<template>
<div>
    <p>To prevent spam, the major cell phone carries require that you register your organization with The Campaign Registry (TCR).  RedChirp handles this for you using the information you provide below.</p>

    <v-text-field
        label="Legal Company Name"
        v-model="tcr_setup_data.organization_legal_name"
        autocomplete="off"
        hint="This should match *exactly* what the IRS has on file for your company's EIN."
        v-on:input="update"
        persistent-hint
    />

    <v-checkbox
        label="Does your business have a different DBA (Doing Business As)?"
        v-model="tcr_setup_data.has_dba"
        v-on:change="doUpdate"
    />

    <v-text-field
        label="DBA"
        v-model="tcr_setup_data.dba"
        autocomplete="off"
        v-on:input="update"
        v-if="tcr_setup_data.has_dba"
        hint="DBA or Brand Name, if different from legal name"
    />

    <v-select
        label="Legal Form"
        v-model="tcr_setup_data.tcr_legal_form"
        :items="$rc.enumChoices('tcr_organiztion_legal_form',false)"
        hint="Choose which best describes your organization. Most RedChirp customers choose 'Private Company'"
        persistent-hint
        v-on:change="doUpdate"
    />

    <v-text-field
        label="Tax Identification Number"
        v-model="tcr_setup_data.tax_id"
        autocomplete="off"
        v-on:input="update"
        hint="  " 
        persistent-hint
        style="margin-top: 15px"
    />

    <ul
        style="margin-bottom: 15px"
    >
        <li>US Businesses: Use your Employer Identification Number (EIN) </li>
        <ul
            style="margin-bottom: 15px"
        >
            <li>Nine digits</li>
        </ul>


        <li>Canadian Businesses: Nine Digit Business Number (BN 9) </li>
        <ul>
            <li>Nine Digits</li>
            <li>Do <b>not</b> use your BN15</li>
        </ul>
    </ul>

    <v-text-field
        label="Business Address"
        v-model="tcr_setup_data.business_address"
        autocomplete="off"
        v-on:input="update"
        hint="This should match exactly what's on file with the IRS and/or your state/province's business registration office" 
    />

    <v-row>
        <v-col>
            <v-text-field
                label="City"
                v-model="tcr_setup_data.business_address_city"
                autocomplete="off"
                v-on:input="update"
            />
        </v-col>

        <v-col>
            <v-text-field
                label="State"
                v-model="tcr_setup_data.business_address_state"
                autocomplete="off"
                v-on:input="update"
            />
        </v-col>

        <v-col>
            <v-text-field
                label="Zip / Postal Code"
                v-model="tcr_setup_data.business_address_zip"
                autocomplete="off"
                v-on:input="update"
            />
        </v-col>

        <v-col>
            <v-select
                label="Country"
                v-model="tcr_setup_data.country"
                :items="$rc.enumChoices('tcr_country',false)"
                persistent-hint
                v-on:change="doUpdate"
            />
        </v-col>
    </v-row>

    <v-select
        label="Which best describes your business vertical (pick one)"
        v-model="tcr_setup_data.tcr_business_category"
        :items="biz_category_choices"
        v-on:change="doUpdate"
    />

     <v-text-field
        label="TCR Point of Contact Email Address"
        v-model="tcr_setup_data.tcr_contact_email"
        autocomplete="off"
        v-on:input="update"
        hint="The Campaign Registry requires we provide an (official) email address for one contact (the primary point of contact) at your organization." 
        persistent-hint
    />

    <v-text-field
        label="TCR Point of Contact Phone Number"
        v-model="tcr_setup_data.tcr_phone_number"
        autocomplete="off"
        v-on:input="update"
        hint="The Campaign Registry requires we provide an (official) phone number for one contact (the primary point of contact) at your organization." 
        persistent-hint
    />

    <v-text-field
        label="Website"
        v-model="tcr_setup_data.website"
        autocomplete="off"
        v-on:input="update"
        hint="Your organization's primary website (e.g. for Microsoft, https://www.microsoft.com)" 
        persistent-hint
    />

    <v-text-field
        label="Privacy Policy"
        v-model="tcr_setup_data.url_privacy_policy"
        autocomplete="off"
        v-on:input="update"
        hint="The web address (URL) for your organization's privacy policy (e.g. for Microsoft, https://privacy.microsoft.com/en-us/privacystatement)" 
        persistent-hint
    />

    <p
        style="margin-top: 15px"
    >
        The major cell phone carriers have a handful of terms they require to be in your privacy policy &mdash;  <a target="_blank" href="https://redchirp.com/texting-requirements-of-your-privacy-policy/">Click here for details and sample language.</a>
    </p>

    <v-text-field
        label="Website Terms and Conditions"
        v-model="tcr_setup_data.url_terms_and_conditions"
        autocomplete="off"
        v-on:input="update"
        hint="The web address (URL) for your organization's terms and conditions (e.g. for Microsoft, https://www.microsoft.com/en-us/legal/terms-of-use)" 
        persistent-hint
    />

    <p
        style="margin-top: 15px"
    >
        The major cell phone carriers have a handful of terms they require to be in your terms and conditions &mdash;  <a target="_blank" href="https://redchirp.com/texting-requirements-and-your-websites-terms-and-conditions/">Click here for details and sample language.</a>
    </p>

    

   
</div>
</template>

<script>
const _ = require('lodash');

export default 
{
    props: {
        profile: {
            type: Object,
            default: function() { return {}; },
        },
    },

    data() {
        return {
            tcr_setup_data: {},
            biz_category_choices: [
                "Agriculture",
                "Media and Communication",
                "Construction, Materials, and Trade Services",
                "Education",
                "Energy and Utilities",
                "Entertainment",
                "Financial Services",
                "Gambling and Lottery",
                "Government Services and Agencies",
                "Healthcare and Life Sciences",
                "Hospitality and Travel",
                "HR, Staffing or Recruitment",
                "Insurance",
                "Legal",
                "Manufacturing",
                "Non-profit Organization",
                "Political",
                "Postal and Delivery",
                "Professional Services",
                "Real Estate",
                "Retail and Consumer Products",
                "Information Technology Services",
                "Transportation or Logistics",
            ],
        }
    },

    mounted () {
        this.tcr_setup_data = _.cloneDeep(this.profile.tcr_setup_data);

        if ( this.tcr_setup_data.country == null )
            this.tcr_setup_data.country = 'us';
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/welcome/tcr-organization-setup-data',
            
                'params' : this.tcr_setup_data,
            
                'on_success': (data) => {
                        if ( data.complete == true )
                        {
                            this.$emit('reload');
                        }
                    },
            
                'on_error': 'Unable to save form data',
            });
        },
        
    },
}
</script>

<style lang="scss" scoped>

</style>

<!--
	
	final private Optional<String> ;
	final private Optional<String> tcr_phone_number;
    -->